import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  AddOrganizationUserRequest,
  AddOrganizationUserResponse,
  GetUsersPayload,
  GetUsersResponse,
  PatchUserPayload
} from "@/types/user";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getUser = async (id?: string) => {
  try {
    const { data } = await axiosInstance.get(`/v1/users/${id}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getUsers = async (params?: GetUsersPayload) => {
  try {
    const { data }: { data: GetUsersResponse } = await axiosInstance.get(
      "/v1/users",
      {
        params
      }
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const postOrganizationUser = async (
  userData: AddOrganizationUserRequest
): Promise<AddOrganizationUserResponse> => {
  try {
    const { data } = await axiosInstance.post(`/v1/users`, userData);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);

    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const postResendActivation = async (userId: string) => {
  try {
    const { data } = await axiosInstance.post(
      `/v1/users/${userId}/resend-activation`
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const patchUser = async (
  userId: string,
  userData: Partial<PatchUserPayload>
) => {
  try {
    const { data } = await axiosInstance.patch(`/v1/users/${userId}`, userData);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const deleteOrganizationUser = async (userId: string) => {
  try {
    const { data } = await axiosInstance.delete(`/v1/users/${userId}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
